import { Plus } from 'lucide-react';
import React from 'react';
import { Button, Tooltip, FormDrawer } from '../../ui';
import FormEntite from '../Forms/FormEntite';

export default function AddEntite(props: { handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        props.handleFunction()
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Ajouter une nouvelle entité">
                <Button
                    size='sm'
                    className="float-right"
                    variant="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => setOpen(true)}
                >Ajouter</Button>
            </Tooltip>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Ajout d'une nouvelle entité"
                hint="Renseignez les informations de l'entité : code, libellé, localisation, responsable et téléphone."
            >
                <FormEntite />
            </FormDrawer>
        </div>
    );
}
